import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import { FaStar } from "react-icons/fa";

function Main() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const stars = (
    <div className="stars">
      <FaStar />
      <FaStar />
      <FaStar />
      <FaStar />
      <FaStar />
    </div>
  );

  return (
    <div className="main">
      <section
        className="hero-section"
        style={{
          backgroundImage: "url('/products/freshbox-fridge-drawer.png')",
        }}
      >
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="hero-text-container">
            <h1>
              Organize Freshness
              <br />
              Keep Your Fridge Tidy
              <br />
              Make Meal Prep Easier
            </h1>
            <p className="hero-quote">
              Food Containers and Storage Bags
              <br />
              For Every Meal and Every Routine
            </p>
            <Link to="/shop" onClick={toTop} className="btn-yellow">
              Shop Food Storage
            </Link>
            <div className="hero-reviews">
              {stars}
              <span>Helpful search terms included on every product page</span>
            </div>
          </div>
        </div>
      </section>

      <section className="versatile-storage">
        <div className="storage-header">
          <h5>Refrigerator Organization</h5>
          <h2>A place for everything, from ingredients to packed lunches</h2>
          <p>Clear, sealed, and available in practical sizes for refrigerating, freezing, and carrying.</p>
        </div>
        <div className="storage-split">
          <div className="storage-text">
            <h2>Food Storage Containers</h2>
            <p>
              Glass, ceramic, stainless steel, and clear containers,
              <br />
              easy to choose by material and purpose.
            </p>
            <Link to="/shop" onClick={toTop} className="btn-yellow">
              Explore Containers
            </Link>
          </div>
          <div className="storage-image">
            <img
              src="/products/freshbox-glass-set.png"
              alt="Heat-resistant glass food container set"
            />
          </div>
        </div>
      </section>

      <section className="what-we-do-best">
        <h5>Shop by Use</h5>
        <h2>Everyday storage essentials for your kitchen</h2>
        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon">
              <img
                src="/products/freshbox-glass-lock.png"
                alt="Four-sided lock glass food container"
              />
            </div>
            <h3>Airtight Storage</h3>
            <p>Sealed, locking lids help organize leftovers, meal prep, and fresh produce.</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <img src="/products/freshbag-zipper.png" alt="Double-zip food storage bags" />
            </div>
            <h3>Flexible Portions</h3>
            <p>Resealable, pull-out, and freezer bags for snacks, pantry goods, produce, and meat.</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <img
                src="/products/freshbag-silicone.png"
                alt="Reusable silicone food storage bags"
              />
            </div>
            <h3>Wash and Reuse</h3>
            <p>Reusable silicone bags and durable containers for frequent everyday organization.</p>
          </div>
        </div>
      </section>

      <section className="grotto-types">
        <h2>Three Everyday Storage Favorites</h2>
        <div className="types-grid">
          <div className="type-item">
            <img
              src="/products/freshbox-fridge-drawer.png"
              alt="Drawer-style refrigerator storage box"
            />
            <h3>Drawer Storage Box</h3>
            <p>Clear and stackable, with easy access to small packets and produce.</p>
            <p className="stores-text">Ideal for refrigerator zones</p>
            <p className="dims-text">Search: clear refrigerator drawer storage box</p>
            <Link to="/shopDetails/102" onClick={toTop} className="view-link">
              View Product
            </Link>
          </div>
          <div className="type-item">
            <img
              src="/products/freshbox-bento-bamboo.png"
              alt="Sectioned lunch box with lid"
            />
            <h3>Sectioned Lunch Box</h3>
            <p>Keep grains, vegetables, and sides separate for meals on the go.</p>
            <p className="stores-text">Perfect for individual meals and packed lunches</p>
            <p className="dims-text">Search: sectioned ceramic lunch box with lid</p>
            <Link to="/shopDetails/103" onClick={toTop} className="view-link">
              View Product
            </Link>
          </div>
          <div className="type-item">
            <img
              src="/products/freshbag-vacuum-roll.png"
              alt="Textured vacuum sealer bag roll"
            />
            <h3>Textured Vacuum Bags</h3>
            <p>Cut each roll to length for batch portions and freezer storage.</p>
            <p className="stores-text">Fits most home vacuum sealers</p>
            <p className="dims-text">Search: textured vacuum sealer bag rolls</p>
            <Link to="/shopDetails/117" onClick={toTop} className="view-link">
              View Product
            </Link>
          </div>
        </div>
      </section>

      <section className="featured-post">
        <div className="post-text">
          <h5>Shopping Tip</h5>
          <h2>Choose the material first, then the capacity.</h2>
          <p>Consider reheating, freezing, and portability to find the right size.</p>
          <Link to="/shop" onClick={toTop} className="read-more">
            Start Shopping
          </Link>
        </div>
        <div
          className="post-image"
          style={{
            backgroundImage: "url('/products/freshbox-steel-bowl.png')",
          }}
        />
      </section>

      <section className="meet-founder">
        <div
          className="founder-image"
          style={{
            backgroundImage: "url('/products/freshbag-roll-dispenser.png')",
          }}
        />
        <div className="founder-text">
          <h5>Easy to Search</h5>
          <h2>Every product includes helpful search terms</h2>
          <p>
            Product pages include clear, familiar search phrases so you can compare capacity, material, quantity, and price across retailers.
          </p>
          <Link to="/shop" onClick={toTop} className="btn-yellow">
            Browse All Storage Essentials
          </Link>
        </div>
      </section>

      <section className="reviews-section">
        <h2>Everyday Freshness Starts with Organization</h2>
        <h2 className="reviews-title">Three Simple Ways to Use Them</h2>
        <div className="overall-rating">
          <span>Less searching, fewer mixed odors, and less waste</span>
        </div>
        <div className="reviews-grid">
          <div className="review-item">
            {stars}
            <h4>Weekend Meal Prep</h4>
            <p>Portion grains, vegetables, and proteins into containers of different sizes.</p>
          </div>
          <div className="review-item">
            {stars}
            <h4>Freezer Portions</h4>
            <p>Pack single-use portions in sealed bags for convenient access.</p>
          </div>
          <div className="review-item">
            {stars}
            <h4>Refrigerator Zones</h4>
            <p>Separate breakfast foods, snacks, and condiments in clear drawer boxes.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Main;
